import { Link } from "react-router";
import { useMe } from "@/lib/session";
import { BrandMark, Wordmark } from "./brand-mark";

/** Signed in, the logo leads home (the office); signed out, to the landing page. */
export function Logo({ compact, tone = "ink" }: { compact?: boolean; tone?: "ink" | "light" }) {
  const { data: me } = useMe();
  return (
    <Link to={me ? "/" : "/about"} className="flex min-w-0 items-center" aria-label={me ? "Expert Column AI ホーム" : "Expert Column AI サービスの紹介"}>
      {compact ? <BrandMark tone={tone === "light" ? "light" : "ink"} /> : (
        <>
          <span className="min-[400px]:hidden"><BrandMark tone={tone === "light" ? "light" : "ink"} /></span>
          <span className="hidden min-w-0 min-[400px]:block"><Wordmark tone={tone} /></span>
        </>
      )}
    </Link>
  );
}
